import { render, staticRenderFns } from "./FrenchBanner.vue?vue&type=template&id=0ba40ff1&lang=pug&"
import script from "./FrenchBanner.vue?vue&type=script&lang=js&"
export * from "./FrenchBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports